export default {
  'policy.privacy.title_1':
    '<h3>隱私權條款</h3>' +
    '多肉男子文化推廣協會 隱私權聲明與個資使用同意條款' +
    '<br />' +
    '最後更新日期：2025年 8月 31日',
  'policy.privacy.title_2':
    '多肉男子文化推廣協會（以下簡稱「本協會」）非常重視申請人與會員的個人資料與隱私保護。為了保障您的權益，並遵守《個人資料保護法》相關規定，我們特此說明以下個資蒐集、使用與管理政策。',
  'policy.privacy.paragraph_1':
    '<h4>一、個人資料蒐集目的</h4>' +
    '本協會蒐集您的個人資料，係為以下特定目的：' +
    '<ul>' +
    '<li>入會資格審查與會員身分確認</li>' +
    '<li>活動報名、票券發送與活動通知</li>' +
    '<li>提供會員專屬資訊與功能（如會員頁面登入、社團報名、通知寄送）</li>' +
    '<li>活動安全與會場入場管理</li>' +
    '<li>會員服務與回覆聯繫需求</li>' +
    '<li>統計分析與活動改善參考（不涉及個別資料揭露）</li>' +
    '</ul>',
  'policy.privacy.paragraph_2':
    '<h4>二、蒐集之個人資料類別</h4>' +
    '依據您填寫之入會申請內容，我們可能會蒐集以下資訊：' +
    '<ul>' +
    '<li>姓名</li>' +
    '<li>出生年月日</li>' +
    '<li>身分證字號</li>' +
    '<li>聯絡方式（如 Email、LINE ID、社群帳號等）</li>' +
    '<li>地址</li>' +
    '<li>性別與性傾向（限於確認入會條件使用，不對外公開）</li>' +
    '<li>個人偏好／社團創作簡介（作為活動審核參考）</li>' +
    '</ul>',
  'policy.privacy.paragraph_3':
    '<h4>三、個人資料使用方式與期間</h4>' +
    '您的個人資料將由本協會於台灣地區境內使用，使用期間為會員存續期間或活動管理所需時間。' +
    '<br />' +
    '您的資料僅供協會內部使用，不會任意揭露、轉讓、販售、出租予任何第三方。' +
    '<br />' +
    '除法律另有規定或經您書面同意外，本協會不會將您的資料提供予第三人。',
  'policy.privacy.paragraph_4':
    '<h4>四、資料保護措施</h4>' +
    '本協會將採行合理之技術與管理安全措施保護您的個人資料，避免未經授權之存取、洩漏、竄改或毀損。',
  'policy.privacy.paragraph_5':
    '<h4>五、您的權利</h4>' +
    '依據《個資法》第3條規定，您可向本協會提出以下請求：' +
    '<ul>' +
    '<li>查詢或請求閱覽您的個人資料</li>' +
    '<li>請求提供複製本</li>' +
    '<li>請求補充或更正（須提供正當理由）</li>' +
    '<li>請求停止蒐集、處理或利用</li>' +
    '<li>請求刪除（將終止您的會員資格）</li>' +
    '</ul>' +
    '請透過本協會聯絡管道提出書面或電子申請，我們將於合理期間內處理。',
  'policy.privacy.paragraph_6':
    '<h4>六、其他事項</h4>' +
    '若您未滿18歲，請勿申請加入本協會。' +
    '<br />' +
    '若您不同意本條款，請勿填寫會員申請表。' +
    '<br />' +
    '本協會有權依法律或業務需要隨時修改本條款，最新版本將公布於協會網站或官方平台。',
  'policy.usage.title':
    '<h3>會員條款</h3>' +
    '請您詳細閱讀以下條款，確認理解並同意後再行申請加入本協會。',
  'policy.usage.paragraph_1':
    '<h4>一、會員資格</h4>' +
    '<ol>' +
    '<li>申請人須為年滿18歲，具完全法律行為能力之男性。</li>' +
    '<li>申請人須為生理男性，且性傾向為男性。</li>' +
    '<li>' +
    '申請人須充分理解並認同本協會推廣之GMPD文化核心價值，願意以尊重、友善之態度參與協會活動。' +
    '</li>' +
    '<li>本協會保留審核申請與取消會員資格之權利，並無義務對外說明理由。</li>' +
    '</ol>',
  'policy.usage.paragraph_2':
    '<h4>二、會員義務</h4>' +
    '<ol>' +
    '<li>遵守本協會規章與各項活動辦法。</li>' +
    '<li>尊重其他會員之性傾向、性格、身體特徵與隱私。</li>' +
    '<li>配合活動流程與管理人員指示，維護交流空間的友善與安全。</li>' +
    '<li>不得以協會名義進行任何侵權、騷擾、詐騙或損害協會名譽之行為。</li>' +
    '<li>若會員行為違反社群規範，經勸導無效，本協會得中止其參與權利或取消其會員資格。</li>' +
    '</ol>',
  'policy.usage.paragraph_3':
    '<h4>三、禁止事項</h4>' +
    '為維護社群品質，以下行為將導致會員資格被暫停或終止：' +
    '<ul>' +
    '<li>任何針對男同性戀或多元體型的歧視、污辱、排斥、攻擊言論或行為。</li>' +
    '<li>利用協會平台進行個人騷擾、不當搭訕、強迫性言行。</li>' +
    '<li>在活動或社群中造成騷擾、分裂或擾亂秩序。</li>' +
    '<li>未經許可擅自使用協會名義進行商業或非商業行為。</li>' +
    '<li>傳播誤導性訊息或冒名頂替他人申請入會。</li>' +
    '</ul>',
  'policy.usage.paragraph_4':
    '<h4>四、個人資料使用</h4>' +
    '<ol>' +
    '<li>會員所提供之個人資料，僅供本協會內部審核與聯繫使用。</li>' +
    '<li>本協會承諾不對外公開會員個資，亦不會將資料交予第三方。</li>' +
    '<li>會員如欲查閱、更正或刪除個人資料，可主動提出申請。</li>' +
    '</ol>',
  'policy.usage.paragraph_5':
    '<h4>五、其他事項</h4>' +
    '<ol>' +
    '<li>本協會可視營運需求修改本條款，並公告於官方平台，不另行個別通知。</li>' +
    '<li>會員若不同意修改內容，得隨時申請退出會員資格。</li>' +
    '<li>條款若有中英文版本解釋不一致時，以中文為準。</li>' +
    '</ol>',
};
